import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { api } from '@bayclubs/utils';
import { map } from 'rxjs';
import { campsenum } from '../../models/enums.generated';
import { camps } from '../../models/models.generated';
import { PurchaseApiService } from '../../services/api/purchase-api.service';

@Component({
  selector: 'app-enrollment-info-tile',
  templateUrl: './enrollment-info-tile.component.html',
  styleUrls: [ './enrollment-info-tile.component.scss' ],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnrollmentInfoTileComponent {

  private readonly service = inject(PurchaseApiService);

  readonly modelResource = rxResource({
    stream: () => this.service.search(<camps.CampPurchaseSearchRequest>{
      take: 5,
      sorting: <camps.SortParameters>{ order: campsenum.SortOrder.Desc, fieldName: 'finalized at' },
      statuses: [ campsenum.CampPurchaseStatus.Finalized, campsenum.CampPurchaseStatus.Refunded ]
    }, false).pipe(
      map((response: api.OperationPagedResult<camps.CampPurchaseInfo>) => response.pageItems)
    )
  });

  protected readonly campsenum = campsenum;
}
